export default "__VITE_ASSET__DbHugTs9__"